import { useContext } from 'react'
import { MenuOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import classNames from 'classnames/bind'
import { RowContext } from '../Row/Row'

import styles from './drag-handle.scss'

const cn = classNames.bind(styles)

export const DragHandle: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext)

  return (
    <Button
      disabled={disabled}
      icon={<MenuOutlined />}
      className={cn('drag-btn', {
        'drag-btn--disabled': disabled,
      })}
      ref={setActivatorNodeRef}
      {...(!disabled ? listeners : {})}
    />
  )
}
